import { FC } from "react";

import dynamic from "next/dynamic";

import { TicketingSkeletonProps } from "./types";

// Disabled SSR to avoid memory leak caused by styled
export const TicketingSkeleton = dynamic(
  () => import("./TicketingSkeletonSsr").then((mod) => mod.TicketingSkeletonSsr),
  {
    ssr: false,
  }
) as FC<TicketingSkeletonProps>;
